import '@adornis/digitale-helden-shared/features/animations/client/animation-live.js';
import { stateful } from '@adornis/functional-lit/stateful';
import { useQuery } from '@adornis/functional-lit/use-query';
import { nothing, type TemplateResult } from 'lit';
import type { DirectiveResult } from 'lit/async-directive';
import { getPublishment } from '../api/getPublishment';
import type { Publishment } from '../db/Publishment';

export const PublishmentHook = stateful(
  ({
    entityID,
    visualizeHook,
  }: {
    entityID;
    visualizeHook: (publishment: Publishment) => TemplateResult | DirectiveResult;
  }) => {
    const { value: publishment, loading } = useQuery(() => getPublishment(entityID)({ _id: 1 }));
    if (loading || !publishment) return nothing;
    return visualizeHook(publishment);
  },
);
